jQuery(document).ready(function($){
	var windowWidth = $( window ).width();
	var windowHeight = $( window ).height();

	// Scroll down 1px to trigger scroll-loading items
	$(window).scrollTop($(window).scrollTop()+1);
	// Scroll down 1px on ajax-load-more button click
	$('.alm-load-more-btn').click(function() {
		function scrollDown() {
			$(window).scrollTop($(window).scrollTop()+1);
		}
		setTimeout(scrollDown, 2000);
	});




/* FOOTER FUNCTIONS */
(function($) {

  /**
   * Copyright 2012, Digital Fusion
   * Licensed under the MIT license.
   * http://teamdf.com/jquery-plugins/license/
   *
   * @author Sam Sehnert
   * @desc A small plugin that checks whether elements are within
   *     the user visible viewport of a web browser.
   *     only accounts for vertical position, not horizontal.
   */

  $.fn.visible = function(partial) {

      var $t            = $(this),
          $w            = $(window),
          viewTop       = $w.scrollTop(),
          viewBottom    = viewTop + $w.height(),
          _top          = $t.offset().top,
          _bottom       = _top + $t.height(),
          compareTop    = partial === true ? _bottom : _top,
          compareBottom = partial === true ? _top : _bottom;

    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

  };

})(jQuery);

$(window).scroll(function(event) {

  $(".module").each(function(i, el) {
    var el = $(el);
    if (el.visible(true)) {
      el.addClass("come-in");
    }
  });

});

var win = $(window);
var allMods = $(".module");

// Already visible modules
allMods.each(function(i, el) {
  var el = $(el);
  if (el.visible(true)) {
    el.addClass("already-visible");
  }
});

win.scroll(function(event) {

  allMods.each(function(i, el) {
    var el = $(el);
    if (el.visible(true)) {
      el.addClass("come-in");
    }
  });

});


  $(document).on("click", ".scroll-to", function (event) {
    event.preventDefault();

    $("html, body").animate({
        scrollTop: $($.attr(this, "href")).offset().top,
      },
      500
    );
  });

	// Remove class to hide unstyled content
	$('.no-fouc').removeClass('no-fouc');


/* HEADER/MENU FUNCTIONS */

		// Mobile menu
		// Mobile menu
    var $mobileMenu = $(".mobile-menu-button");
    var $siteMenu = $(".site-header");
    var $mobileMenuWrapper = $('.mobile-menu-wrapper');

    function toggleMenu() {
      $siteMenu.toggleClass("is-active");
      $mobileMenuWrapper.toggleClass('is-active');
      $('.site-header').toggleClass('popout-menu-is-active');
    }

    function handleDesktopMenu() {
      var isHovering = false;
      var hoverTimeout;

      $siteMenu.hover(
        function() {
          isHovering = true;
          clearTimeout(hoverTimeout);
          if (!$siteMenu.hasClass("is-active")) {
            toggleMenu();
          }
        },
        function() {
          isHovering = false;
          hoverTimeout = setTimeout(function() {
            if (!isHovering && $siteMenu.hasClass("is-active")) {
              toggleMenu();
            }
          }, 300); // Adjust this delay as needed
        }
      );

      $mobileMenu.on("click", function(e) {
        e.preventDefault();
      });
    }

    function handleMobileMenu() {
      $mobileMenu.on("click", function(e) {
        toggleMenu();
      });
    }

    function setupMenu() {
      if (window.matchMedia('(min-width: 1025px)').matches) {
        handleDesktopMenu();
      } else {
        handleMobileMenu();
      }
    }

    setupMenu();

    $(window).on('resize', function() {
      setupMenu();
    });
		

		// Hide/show navigation based on scroll direction
		$(function(){
			var lastScrollTop = 0, delta = 180;
			$(window).scroll(function(event){
				var st = $(this).scrollTop();

				if(Math.abs(lastScrollTop - st) <= delta)
					return;

				if (st > lastScrollTop){
					// downscroll code
					$('.site-header').addClass('hide-menu');
					$('.mobile-menu-button-wrapper').addClass('show-mobile-menu');
				} else {
					// upscroll code
					//$('.site-header').removeClass('hide-menu');
				}
				lastScrollTop = st;
			});
		});


		$(window).scroll(function() {
			if($(window).scrollTop() < 180) {
				$('.site-header').removeClass('hide-menu');
				$('.mobile-menu-button-wrapper').removeClass('show-mobile-menu');
			} else {
				$('.site-header').addClass('hide-menu');
				$('.mobile-menu-button-wrapper').addClass('show-mobile-menu');
			}
		});

		// Add current class to menu items
		if ( $('body').hasClass('single-post') ) { $('.menu-item-33').addClass('current-menu-item'); }
		if ( $('body').hasClass('single-case-study') ) { $('.menu-item-32').addClass('current-menu-item'); }


/* HOMEPAGE FUNCTIONS */

		// Scroll down
		/*
		$('.video-background .intro-link').click(function(e) {
			e.preventDefault();
			$('html, body').animate({scrollTop: $('.homepage-top-section').offset().top }, 1000);
		});
		*/

		// Homepage slider
		$('#homepage-slider').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			speed: 1500,
			autoplay: true,
			autoplaySpeed: 7000,
			dots: false,
			arrows: false,
			// fade: true,
			cssEase: 'linear',
			pauseOnHover: false,
			pauseOnFocus: false,
	  });

    // Homepage Video and Image slider
    var $videoImgSlider = $('.video-image-slider');
    $videoImgSlider.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
      //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      var i = (currentSlide ? currentSlide : 0) + 1;
      $('.slider-counter .current').html(i);
    });
    $videoImgSlider.slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			speed: 1500,
			autoplay: true, 
			autoplaySpeed: 7000,
			dots: false,
			arrows: true,
      		nextArrow: $('.arrow-next'),
			fade: false,
			cssEase: 'linear',
			pauseOnHover: false,
			pauseOnFocus: false,
			centerMode: true,
	  });


    // Services image slider
		$('.image-gallery-slider').slick({
			infinite: true,
			slidesToShow: 2,
      centerMode:true,
			slidesToScroll: 1,
			speed: 1500,
			// autoplay: true,
			autoplaySpeed: 4500,
			dots: false,
			arrows: true,
      nextArrow: $('.img-slider-arrow-next'),
      prevArrow: $('.img-slider-arrow-prev'),
			fade: false,
			cssEase: 'linear',
			pauseOnHover: false,
			pauseOnFocus: false,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 1,
            slidesToScroll:1
          }
        },
      ]
	  });



		// Testimonials slider
	  var testimonialSlider = $('#testimonial-slider');
	  testimonialSlider.owlCarousel({
	  	items: 1,
	  	//autoPlay: true,
	  	singleItem : true,
	    transitionStyle : 'fade',
	  	navigation: true,
	  	animateOut: 'fadeOut',
	  });

	  // Case studies slider
	  var caseStudiesSlider = $('#case-studies-slider');
	  caseStudiesSlider.owlCarousel({
	  	items: 1,
	  	autoPlay: true,
	  	singleItem : true,
	    transitionStyle : 'fade',
	  	navigation: true,
	  	animateOut: 'fadeOut',
	  });


		// Twitter slider
		var witterSlider = $('.twitter-feed__slider');
	  witterSlider.owlCarousel({
	  	items: 1,
	  	autoPlay: true,
	  	singleItem : true,
	    transitionStyle : 'fade',
	  	navigation: true,
	  	animateOut: 'fadeOut',
	  });


/* PAGE FUNCTIONS */

		// Image slideshow
		 $('#page-slider').carouFredSel({
	      items : {
	      	visible 					: 2,
	      	start 						: -1,
	      },
	      direction            : "left",
	      infinite						 : true,
	      circular						 : true,
	      height 							 : 490,
	      auto 								 : false,
	      swipe : {
	        onTouch 				: true,
	        onMouse 				: true
	    	},
	      scroll : {
	        items           : 1,
	        easing          : "linear",
	        duration        : 800,
	        pauseOnHover    : false,
	        pauseDuration   : 0
	      },
	      prev : {
	      	button 				  : "#thumbnail-slider_prev",
	      	key							: "left",
	      	duration 				: 250,
	      	easing 					: "swing"
	      },
	      next : {
	      	button 					: "#thumbnail-slider_next",
	      	key							: "right",
	      	duration 				: 250,
	      	easing 					: "swing"
	      }
	    }).trigger("pause");

		if ( windowWidth < 1007 ) {
			var itemsVisible = 1
			$('#page-slider').trigger('configuration', [
				'items', {
					visible : itemsVisible
				}
			], true);
		} else {
			var itemsVisible = 2
			$('#page-slider').trigger('configuration', [
				'items', {
					visible : itemsVisible
				}
			], true);
		}
		$( window ).resize(function() {
			var windowWidth = $( window ).width();
			if (windowWidth < 1007) {
				var itemsVisible = 1
				$('#page-slider').trigger('configuration', [
					'items', {
						visible : itemsVisible
					}
				], true);
			} else {
				var itemsVisible = 2
				$('#page-slider').trigger('configuration', [
					'items', {
						visible : itemsVisible
					}
				], true);
			}
		});


		 // Open team member popups
		$('.team-wrapper').magnificPopup({
			delegate: '.wrap-link',
			removalDelay: 500, //delay removal by X to allow out-animation
			callbacks: {
				beforeOpen: function() {
					this.st.mainClass = this.st.el.attr('data-effect');
				}
			},
			gallery: {
				enabled: true,
				navigateByImgClick: true,
				preload: [0,1] // Will preload 0 - before current, and 1 after the current image
			},
			midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
		});
		// Add click function to new buttons
		var magnificPopup = $.magnificPopup.instance;
		$('body').on('click', '.next-popup', function() {
		    magnificPopup.next();
		});
		$('body').on('click', '.prev-popup', function() {
		    magnificPopup.prev();
		});


		// On load more projects, scroll down 1px to reveal first item
		$('.alm-load-more-btn').bind("click touchstart", function() {
			function scrollDown() {
				$(window).scrollTop($(window).scrollTop()+1);
			}
			setTimeout(scrollDown, 800);
		});


		// Open gallery images in lightbox
		$('.gallery').magnificPopup({
			delegate: 'a',
			type: 'image',
			tLoading: 'Loading image #%curr%...',
			mainClass: 'mfp-img-mobile',
			gallery: {
				enabled: true,
				navigateByImgClick: true,
				preload: [0,1] // Will preload 0 - before current, and 1 after the current image
			},
			image: {
				tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
			}
		});


		// Open homepage video in lightbox
    $('.video-modal').magnificPopup({
      type: 'iframe',
			mainClass: 'mfp-fade',
			removalDelay: 160,
			preloader: false,
			fixedContentPos: false,

			iframe: {
				markup: '<div class="mfp-iframe-scaler">' +
					'<div class="mfp-close"></div>' +
					'<iframe class="mfp-iframe" frameborder="0" allow="autoplay"></iframe>' +
					'</div>',
				patterns: {
					youtu: {
						index: 'youtu.be',
						id: function( url ) {

							// Capture everything after the hostname, excluding possible querystrings.
							var m = url.match( /^.+youtu.be\/([^?]+)/ );

							if ( null !== m ) {
								return m[1];
							}

							return null;

						},
						// Use the captured video ID in an embed URL.
						// Add/remove querystrings as desired.
						src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0'
					},
					youtube: {
						index: 'youtube.com/',
						id: 'v=',
						src: 'https://www.youtube.com/embed/%id%?autoplay=1'
					}
				}
			}
    });


		// Open download popup
		$('.download-section').magnificPopup({
			delegate: '.info-box a',
			removalDelay: 500, //delay removal by X to allow out-animation
			callbacks: {
				beforeOpen: function() {
					this.st.mainClass = this.st.el.attr('data-effect');
				}
			},
			midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
		});


/* CONTACT PAGE FUNCTIONS */
		// Add current focus class to input wrapper for styling labels
		function addFocusClassToGravityForm() {
			$(".gform_wrapper input[type='text'], .gform_wrapper input[type='email'], .gform_wrapper input[type='tel'], .gform_wrapper textarea").focus(function() {
				$(this).parent().parent().addClass("input-focus");
			});

			$(".gform_wrapper input[type='text'], .gform_wrapper input[type='email'], .gform_wrapper input[type='tel'], .gform_wrapper textarea").blur(function() {
				$(this).parent().parent().removeClass("input-focus");

				// Add class if input is empty or filled for styling labels
				if( $(this).val().length === 0 ) {
		      $(this).parent().parent().addClass('input-empty');
		      $(this).parent().parent().removeClass('input-filled');
		    } else {
		    	$(this).parent().parent().removeClass('input-empty');
		    	$(this).parent().parent().addClass('input-filled');
		    }
			});
		}
		if ( $(".gform_wrapper")[0] ) {
			addFocusClassToGravityForm();
		}


/* TABS */ 
const tabsContainer = document.querySelectorAll('[data-name="tabs-container"]');

if ( tabsContainer.length === 0 ) return;

tabsContainer.forEach(container => {
  const tabList   = container.querySelector('[role="tablist"]');
  const tabs      = Array.from(container.querySelectorAll('[role="tab"]'));
  const tabPanels = Array.from(container.querySelectorAll('[role="tabpanel"]'));

  let focusedTab = 0;

  tabList.addEventListener("keydown", handleTabListKeydown);

  for (const tab of tabs) {
    tab.addEventListener("click", handleTabClick);
  }

  function updateTabFocus() {
    for (const tab of tabs) {
      tab.setAttribute("tabindex", -1);
    }
    tabs[focusedTab].setAttribute("tabindex", 0);
    tabs[focusedTab].focus();
  }

  function handleTabListKeydown(event) {
    const key = event.key;

    if (key === "ArrowRight" || key === "ArrowLeft") {
      if (key === "ArrowRight") {
        focusedTab++;
        if (focusedTab >= tabs.length) {
          focusedTab = 0;
        }
      } else if (key === "ArrowLeft") {
        focusedTab--;
        if (focusedTab < 0) {
          focusedTab = tabs.length - 1;
        }
      }
      updateTabFocus();
    }
  }

  function handleTabClick(event) {
    const target = event.target;
    const selectedTabIndex = tabs.indexOf(target);

    for (const tab of tabs) {
      tab.setAttribute("aria-selected", false);
    }
    target.setAttribute("aria-selected", true);

    for (const panel of tabPanels) {
      panel.setAttribute("hidden", true);
    }
    container
      .querySelector(`#${target.getAttribute("aria-controls")}`)
      .removeAttribute("hidden");

    focusedTab = selectedTabIndex;
    updateTabFocus();
  }
});


// ACCORDION
function closeAllAccordions(accordions, clickedAccordion) {
  accordions.forEach((accordion) => {
    if ( accordion === clickedAccordion ) return; // skip the clicked accordion

    const content = accordion.querySelector('[data-target="accordion-content"]');
    accordion.dataset.state = 'closed';
  });
}


function accordion() {
  const accordions =  document.querySelectorAll('[data-target="accordion"]');

  if ( ! accordions ) return;

  accordions.forEach((accordion) => {
    const trigger = accordion.querySelector('[data-target="accordion-trigger"]');
    const content = accordion.querySelector('[data-target="accordion-content"]');

    trigger.addEventListener('click', (event) => {
      const { state } = accordion.dataset;

      closeAllAccordions(accordions, event.currentTarget.parentNode);

      if ( state === 'closed' ) {
        accordion.dataset.state = 'open';
      } else {
        accordion.dataset.state = 'closed';
      }
    });
  });
}
accordion();



/* SIDEBAR FUNCTIONS */

	if ( windowWidth > 1024 ) {
		$(".sidebar-menu").stick_in_parent({
			offset_top:50,
			parent: '.page-wrapper',
			//recalc_every: 1,
		});
	}
	$( window ).resize(function() {
		var windowWidth = $( window ).width();
		if ( windowWidth > 1024 ) {
			$(".sidebar-menu").stick_in_parent({
				offset_top:50,
				parent: '.page-wrapper',
			});
		}
	});


  // Show/hide loader on s&f infinite scroll page
  //detects the start of an ajax request being made
	$(document).on("sf:ajaxstart", ".searchandfilter", function(e, event_data){
		if(event_data.type == "load_more"){
			//show your loader
			$('.load-more').addClass('show');
		}

    
	  
	});
	//detects when the ajax request has finished and the content has been updated
	$(document).on("sf:ajaxfinish", ".searchandfilter", function(e, event_data){
		$('.load-more').removeClass('show');

    // Hide categories on portfolio page if view is filtered, show category on main page
    if(window.location.href.indexOf("?_sft_type") != -1) {
      $('.case-study').each( function(i) {
        $(this).find('.meta-category').addClass('hide-category');
      });
    } else {
      $('.case-study').each( function(i) {
        $(this).find('.meta-category').removeClass('hide-category');
      });
    }
	});

  // remove category on filtered portfolio page
  if(window.location.href.indexOf("?_sft_type") != -1) {
    $('.case-study').each( function(i) {
      $(this).find('.meta-category').addClass('hide-category');
    });
  }




  if ( $('body').hasClass('page-template-page-what-we-do') ) {
    $('.page-teaser__content').each(function(i) {
      const h3Height = $(this).find('h3').outerHeight();
      $(this).css('transform', `translateY(calc(100% - 10px - ${h3Height}px))`);
    }); 
  }




});
